import styled, { css } from 'styled-components'

import { breakPointSizeBig } from 'components/page/ForeignProfile/ForeignProfile.constants'
import { media } from 'components/presentational'
import { LinkColorButton, RouterLink } from 'components/presentational/link'

export const ProfilePanel = styled.div`
  width: 100%;
  position: relative;
  display: inline-grid;
  grid-auto-flow: column;
  align-items: center;

  ${media.tablet`
    grid-gap: 10px;
    gap: 10px;
    margin-bottom: 10px;
    justify-content: center;
  `}
`

export const WrapperButtonCss = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  cursor: pointer;
  outline: 0;

  ${media.tablet`
    width: auto;
  `}
`

interface IconWrapperProps {
  $backgroundColor: string
}

export const IconWrapper = styled.div<IconWrapperProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 88px;
  width: 88px;
  position: relative;

  svg {
    position: relative;
    height: 55px;
    width: 55px;
  }

  ${media.tablet<IconWrapperProps>`  
    padding: 5px;  
    width: 62px;
    height: 62px;       
    border-radius: 50%;
    
    &::before {
      position: absolute;
      height: 62px;
      width: 62px;
      content: '';
      background-color: ${(props) => props.$backgroundColor};
      border-radius: 50%;
      z-index: 0;
    }    
    
    svg {
      height: 40px;
      width: 40px;
    }    
  `}
`

export const ProfileButton = styled(LinkColorButton)`
  ${WrapperButtonCss};
`

export const ProfileLink = styled(RouterLink)`
  ${WrapperButtonCss};
`

export const Note = styled.div`
  margin-top: 10px;
  font-size: 21px;
  text-align: center;

  @media (max-width: ${breakPointSizeBig}px) {
    font-size: 15px;
  }

  ${media.tablet`
    display: none;
  `}
`
